import { useUi } from "context/ui/UIContext";
import {
  IOwnerAddressPaymentGuest,
  IOwnerPaymentGuest,
} from "models/paymentGuest/IPaymentGuestForm";
import { IPaymentLinkResponse } from "models/paymentLink/IPaymentLinkResponse";
import { useCallback, useEffect, useMemo, useState } from "react";
import { IPaymentGuestRequest } from "models/paymentGuest/IPaymentGestRequest";
import PaymentLinkApi from "services/Api/paymentLink/PaymentLinkApi";
import { IDigitalWalletPaymentRequest } from "models/digitalWallet/IDigitalWallet";

export const UseApplePay = (paymentLink: IPaymentLinkResponse) => {
  const { toast } = useUi();
  const [approved, setApproved] = useState("");
  const [loading, setLoading] = useState(false);
  const [externalId, setExternalId] = useState("");


  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const externalId = urlParams.get("externalId");
    if (externalId) {
      setExternalId(externalId);
    }
  }, []);

  const [owner, setOwner] = useState<IOwnerPaymentGuest>({
    name: "",
    document: "",
    email: "",
    phoneNumber: "",
    birthDay: "",
    address: {} as IOwnerAddressPaymentGuest,
  });

  const [address, setAddress] = useState<IOwnerAddressPaymentGuest>({
    CEP: "",
    description: "",
    street: "",
    number: "",
    complement: "",
    neighborhood: "",
    city: "",
    state: "",
  });

  const [errors, setErrors] = useState({
    owner: {
      name: "",
      document: "",
      email: "",
      phoneNumber: "",
      //address: "",
      //birthDay: "",
    },
  });

  const validateForm = useCallback((showErrors: boolean = true) => {
    setErrors({
      owner: {
        name: "",
        document: "",
        email: "",
        phoneNumber: "",
        //address: "",
        //birthDay: "",
      },
    });

    let validForm = true;

    if (!owner.name || owner.name.length < 3) {
      if (showErrors) {
        setErrors((prev) => ({
          ...prev,
          owner: { ...prev.owner, name: "Nome inválido" },
        }));
      }
      validForm = false;
    }

    if (!owner.document || owner.document.length < 11) {
      if (showErrors) {
        setErrors((prev) => ({
          ...prev,
          owner: { ...prev.owner, document: "Documento inválido" },
        }));
      }
      validForm = false;
    }

    //if (!owner.birthDay || owner.birthDay.length < 10) {
    //  if (showErrors) {
    //    setErrors((prev) => ({
    //      ...prev,
    //      owner: { ...prev.owner, birthDay: "Data de nascimento obrigatória" },
    //    }));
    //  }
    //  validForm = false;
    //}

    if (!owner.email || owner.email.length < 11 || !owner.email.includes("@")) {
      if (showErrors) {
        setErrors((prev) => ({
          ...prev,
          owner: { ...prev.owner, email: "Email inválido" },
        }));
      }
      validForm = false;
    }

    if (!owner.phoneNumber || owner.phoneNumber.length < 11) {
      if (showErrors) {
        setErrors((prev) => ({
          ...prev,
          owner: { ...prev.owner, phoneNumber: "Telefone inválido" },
        }));
      }
      validForm = false;
    }

    //if (
    //  !address.street ||
    //  !address.number ||
    //  !address.city ||
    //  !address.state
    //) {
    //  if (showErrors) {
    //    setErrors((prev) => ({
    //      ...prev,
    //      owner: { ...prev.owner, address: "Endereço incompleto" },
    //    }));
    //  }
    //  validForm = false;
    //}

    console.log("validForm", validForm);

    return validForm;
  }, [owner.name, owner.document, owner.email, owner.phoneNumber]);


  //const handlePaymentSuccess = useCallback((response: any, status?: string) => {
  //  if (response && status === "1") {
  //    setApproved(response.orderId || "-");
  //    toast("Pagamento aprovado!", "success");
  //  } else {
  //    toast("Erro no pagamento", "error");
  //  }
  //}, [toast]);

  const onClickSend = useCallback(async (payload: IDigitalWalletPaymentRequest) => {
    const paymentLinkApi = PaymentLinkApi();
    console.log("payload", payload);
    console.log("paymentLink", paymentLink);
    console.log("validateForm", validateForm());
    if (paymentLink && validateForm()) {
      console.log("entrou no if");
      const orderValue = paymentLink?.price;
      const newPaymentGuestPayRequest: IPaymentGuestRequest = {
        mePayLinkId: paymentLink?.id,
        externalId: externalId,
        isSinglePayment: true,// paymentLink?.isSinglePayment === true??,
        order: {
          value: orderValue,
          itens: [
            {
              name: paymentLink?.product.nome,
              productId: paymentLink?.product.id,
              value: (paymentLink?.isVariable ?? false) === true ? orderValue : paymentLink?.product.valor,
              quantity: 1,
            },
          ],
        },
        customer: {
          name: owner.name,
          document: owner.document,
          email: owner.email,
          phoneNumber: owner.phoneNumber,
          birthDay: owner.birthDay,
          address: {
            postalCode: address.CEP ?? "",
            street: owner.address.street,
            number: address.number,
            complement: address.complement,
            neighborhood: address.neighborhood,
            city: owner.address.city,
            state: owner.address.state,
            country: "",
          },
        },
        installments: 1,
        storeId: paymentLink.localId,
        digitalWallet: payload,
      };

      setLoading(true);
      console.log("newPaymentGuestPayRequest", newPaymentGuestPayRequest);

      try {
        const payment = await paymentLinkApi.getPaymentGuestSendPay(newPaymentGuestPayRequest);
        //const payment = await callDirectCieloApplePay(payload, owner.name, owner.document, orderValue, "BRL", "MEEP SOLUCOES SA");
        console.log("payment", payment);
        setApproved(payment?.data?.orderId ?? "-");
        toast("Pagamento realizado com sucesso", "success");
        return payment;
      } catch (error) {
        console.error("Erro ao enviar o payload:", error);
        toast((error as any)?.response?.data?.Message ?? "Erro ao realizar o pagamento", "error");
        throw error;
      } finally {
        setLoading(false);
      }


      //paymentLinkApi
      //  .getPaymentGuestSendPay(newPaymentGuestPayRequest)
      //  .then((res) => {
      //    setApproved(res?.data?.orderId ?? "-");
      //  })
      //  .catch((error) => {
      //    toast(error?.response?.data?.Message, "error");
      //  })
      //  .finally(() => {
      //    setLoading(false);
      //  });
    }
  }, [address.CEP, address.complement, address.neighborhood, address.number, externalId, owner.address.city, owner.address.state, owner.address.street, owner.birthDay, owner.document, owner.email, owner.name, owner.phoneNumber, paymentLink, toast, validateForm]);



  return {
    owner,
    setOwner,
    address,
    setAddress,
    approved,
    loading,
    errors,
    validateForm,
    setLoading,
    onClickSend
  };
};


const callDirectCieloApplePay = async (payload: IDigitalWalletPaymentRequest, name: string, document: string, amount: number, currency: string, softDescriptor: string) => {
  const randomId = Math.floor(Math.random() * 10000000000).toString();
  console.log("randomId", randomId);
  const response = await fetch('https://api.cieloecommerce.cielo.com.br/1/sales', {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "MerchantId": "aeaa7cb4-b100-4d75-865a-7f99aed898d9",
      "MerchantKey": "oZ4YF8jgKMKJa2kWZrSoQ6oseUuo2thvgadU1LAf"
    },
    body: JSON.stringify({
      //...data,
      "MerchantOrderId": randomId,
      "Customer": {
        "Name": name,
        "Identity": document,
        "IdentityType": "CPF"
      },
      "Payment": {
        "Type": "CreditCard",
        "Amount": Math.round(amount * 100),
        "Currency": currency,
        "Installments": 1,
        "SoftDescriptor": softDescriptor,
        "Capture": true,
        "Wallet": {
          "Type": "ApplePay",
          "WalletKey": payload.walletKey,
          "AdditionalData": {
            "EphemeralPublicKey": payload.ephemeralPublicKey,
            //"TransactionId": payload.transactionId,
            //"PublicKeyHash": payload.publicKeyHash,
          }
        }
      }

    })
  });
  return response;
}